export default "__VITE_ASSET__1b80e520__"